// extracted by mini-css-extract-plugin
export default {"root":"Feed_root__CCUHI","container":"Feed_container__ung5H","sidebar":"Feed_sidebar__EHyPG","content":"Feed_content__ZMbvv"};